import { WorkflowAPI, WorkflowMaestro } from '@automata/api/apiSchemas';

const transportJson = {
  device_configs: {},
  transport_links: {},
};

const workflowJson = {};

export const initialMaestroWorkflow: WorkflowMaestro = {
  resource_versions: {},
  simulateDrivers: false,
  simulateTime: false,
  transport: JSON.stringify(transportJson),
  workflow: JSON.stringify(workflowJson),
};

export const initialApiWorkflow: WorkflowAPI = {
  cached_api_definition: JSON.stringify(workflowJson),
  batches: 0,
  parameter_values: [],
  cached_maestro_workflow: initialMaestroWorkflow,
  override_transport_on_publish: false,
};
